import { render, staticRenderFns } from "./EditGroupSettings.vue?vue&type=template&id=4243b949&scoped=true"
import script from "./EditGroupSettings.vue?vue&type=script&lang=js"
export * from "./EditGroupSettings.vue?vue&type=script&lang=js"
import style0 from "./EditGroupSettings.vue?vue&type=style&index=0&id=4243b949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4243b949",
  null
  
)

export default component.exports